import { CanMatchFn, UrlSegment } from '@angular/router';

const LTI_FIRST_SEGMENTS = new Set([
  'lti-launch',
  'lti-experiences',
  'lti-experience',
  'lti-admin',
]);

export const isLTIRouteMatch: CanMatchFn = (_route, segments: UrlSegment[]) => {
  const pathSegment = segments[0]?.path;
  if (pathSegment === 'app') return segments[1]?.path === 'tool';
  return LTI_FIRST_SEGMENTS.has(pathSegment);
};
